module.exports = __webpack_public_path__ + "static/img/buddy_pictgrid42_980x785.100dbfd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/buddy_pictgrid42_980x785.jpg
// module id = 0B9B
// module chunks = 0